import { removeHtmlTagsInString } from 'Utils/StringUtils';
import { getContentReferenceList } from 'Services/Delivery';

/**
 * Process mandatory rule list for compare functionality
 * @param {Object} mandatoryRequirementsList - Fetched Annual report data from Kontent `getAContentItem` call
 * @param {Object} extra - Contains extra information (currently not used, leaving in case of future use cases)
 * @returns {{ruleTitle: String, ruleDescription: String, contentReference: Array|null, extraInfo: Object}[]} - List of rules
 */
// eslint-disable-next-line no-unused-vars
export const processCompareFunctionMandatoryRequirements = async (mandatoryRequirementsList, extra = {}) => {
  const mandatoryRequirements = mandatoryRequirementsList?.filter((requirement) => requirement.MandatoryRequirementStaticContent?.IsTableSection?.toLowerCase() === 'no') || [];
  const ruleList = [];
  const mandatoryRequirementsIdList = mandatoryRequirements.map((requirement) => requirement.Id);

  // Fetch mandatory requirements content
  if (mandatoryRequirementsIdList.length > 0) {
    const contentReferenceResponse = await getContentReferenceList(mandatoryRequirementsIdList);
    const contentReferenceList = contentReferenceResponse && Array.isArray(contentReferenceResponse) ? contentReferenceResponse : [];
    mandatoryRequirements.forEach((rule) => {
      const ruleItem = rule?.MandatoryRequirementStaticContent;
      let extraInfo = {};

      const formattedRule = {
        ruleTitle: ruleItem?.PgpaRuleReference || '',
        ruleDescription: ruleItem?.RuleDescription ? removeHtmlTagsInString(ruleItem.RuleDescription) : '',
        contentReference: contentReferenceList?.find((content) => content.Id === rule.Id)?.Content || null,
        extraInfo, // Used in compare function to display pdf at end of content. Currently NOT in use, is always empty
      };

      // Only add requirment if title and description are found for the rule
      if (formattedRule.ruleTitle && formattedRule.ruleDescription) {
        ruleList.push(formattedRule);
      }
    });
  }

  return ruleList;
};
